import { CxEvent } from '@spartacus/core';

export class Ga4GgSliderViewsEvent extends CxEvent {
  event?: string;
  title?: string;
  file_name?: string;
  visitor_type?: string;
}
